module.exports = __webpack_public_path__ + "static/dafitiHome-9f52f74892ecb6c2d7af56d756656850.png";